import React, {Component} from 'react'
import {parseJwt} from "../../../helpers/parseToken"
import {getLocalData} from "../../../services/StorageServices"
import BasketsListContainer from './table/BasketsListContainer'
import { getListBasketsMergeSet } from '../../../services/api/basketsMergerSetApi'
class BasketsMergeSetPage extends Component {
    state = {
        baskets: [],
        total: 0,
        limit: 50,
        page: 1,
        pages: 1,
        loading: false,
        error: '',
        reloadFlag: Date.now()
    }

    interval = null; // lưu interval ID

    componentDidMount() {
        const role = parseJwt(getLocalData('accessToken')).roles
        this.setState({
            isAdmin: role.some(item=> item.name==="Super Admin")
        })

        this._fetchBaskets()

        // Tự động reload API mỗi 5 giây
        this.startAutoReload()
    }

    componentWillUnmount() {
        // Cleanup interval khi component unmount
        this.stopAutoReload()
    }

    startAutoReload = () => {
        this.stopAutoReload() // clear trước để tránh trùng
        this.interval = setInterval(() => {
            this._fetchBaskets()
        }, 300000)
    }

    stopAutoReload = () => {
        if (this.interval) {
            clearInterval(this.interval)
            this.interval = null
        }
    }

    _fetchBaskets = async () => {
        this.setState({
            loading: true,
        })

        try {
            const {data: response} = await getListBasketsMergeSet()

            const {data, success, error} = response

            if (!success) {
                throw new Error(error)
            }

            const {setBaskets = []} = data

            const basketsHaveItem = setBaskets.length > 0 ? setBaskets.filter(item => item.status !== 'free') : []

            this.setState({
                baskets: basketsHaveItem,
                // total,
                // pages,
                loading: false,
                error: '',
                reloadFlag: Date.now(), // cập nhật flag → con detect và reload
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message,
            })
        }
    }

    _handlePageChange = (current) => {
        this.setState({
            page: current,
        }, this._fetchBaskets)
    }

    _handleShowSizeChange = (current, size) => {
        this.setState({
            limit: size,
            page: 1,
        }, this._fetchBaskets)
    }

    _handleSelectBasketToOpenModal = (basketId) => {
        this.setState({ selectedBasketId: basketId });
    }

    render() {
        const {baskets, error, loading, reloadFlag} = this.state

        return (
            <div className='BasketsPage'>
                <div className='container-fluid min-vh-100'>
                    <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                        <div className='mt-3'>
                            <div className='d-flex align-items-center justify-content-between'>
                                <h3>Giỏ gộp SET</h3>
                                <div className="listBtn">
                                    <a className="ant-btn mr-3 ant-btn-secondary" href="/combined-set-statistics">Thống kê giỏ gộp SET</a>
                                </div>
                            </div>
                            
                            <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                                <div>
                                    {error && <div className='text-danger'>{error}</div>}
                                </div>
                            </div>

                            <BasketsListContainer 
                                baskets={baskets} 
                                loading={loading} 
                                reload={this._fetchBaskets}
                                reloadFlag={reloadFlag}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default BasketsMergeSetPage
